var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wy-page-frame"},[_c('iframe',{attrs:{"title":"","src":_vm.url}})])}
var staticRenderFns = []

export { render, staticRenderFns }